module.exports = __webpack_public_path__ + "static/img/logo0506.c036776.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo0506.png
// module id = lnn7
// module chunks = 2